import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import Link from 'next/link'
import { useEffect, useState } from 'react'

interface CookieConsentProps {
  className?: string
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ className = '' }) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const v = localStorage.getItem('isConsentAccepted')
    if (v == null || v == 'undefined' || v != 'true') {
      setVisible(true)
    }
  }, [])
  const onAccept = () => {
    localStorage.setItem('isConsentAccepted', 'true')
    setVisible(false)
  }
  const onDecline = () => {
    localStorage.setItem('isConsentAccepted', 'false')
    setVisible(false)
  }

  const buttonStyle =
    'border-1 border-solid border-[#DDDDDD] bg-white text-darkgray font-secondary font-medium text-[13px] py-[5px] px-[24px] h-full rounded-[1.875rem] flex items-center'
  return (
    <div
      className={cn(
        className,
        'cookieConsentPoup CookieConsent items-center bg-darkgray text-clouds text-[15px] font-primary font-normal flex max-w-screen-2xl w-full fixed z-[999] bottom-0 left-1/2 -translate-x-1/2 justify-between',
        { hidden: !visible },
      )}
    >
      <div className="flex flex-col md:flex-row w-full justify-between items-center mx-3 md:mx-5 md:ml-[33px] my-4">
        <div className="md:w-3/4 w-full">
          <div className="flex flex-row justify-between">
            <div className="w-full md:w-3/4">
              We use cookies to monitor the performance of our website, improve user experience, and assist in our
              marketing efforts. By continuing to browse our site, you agree to our use of cookies.
            </div>
          </div>
        </div>
        <div className="flex flex-wrap md:flex-nowrap items-center justify-center gap-[24px] md:ml-[0px] mx-auto md:mr-[unset] md:my-0 my-4">
          <button className={buttonStyle} onClick={onAccept}>
            Okay
          </button>
          <button className={buttonStyle} onClick={onDecline}>
            No
          </button>
          <Link prefetch={false} href="/cookie-policy">
            <button className={buttonStyle + ' whitespace-nowrap'}>Cookie Policy</button>
          </Link>
          <IonIcon
            name="close"
            className="text-[24px] pr-[15px] cursor-pointer"
            onClick={() => {
              setVisible(false)
            }}
          />
        </div>
      </div>
    </div>
  )
}
